import AcceptDto from "@/domains/dev/eventList/dto/accept.dto.ts";
import CreateDto from "@/domains/dev/eventList/dto/create.dto.ts";
import ProcessDto from "@/domains/dev/eventList/dto/process.dto.ts";
import RentDto from "@/domains/dev/eventList/dto/rent.dto.ts";
import SelectRouteDto from "@/domains/dev/eventList/dto/select-route.dto.ts";
import UpdateDto from "@/domains/dev/eventList/dto/update.dto.ts";
import { BusEvents } from "@/domains/dev/eventList/events/bus-events.ts";
import { TaxiEvents } from "@/domains/dev/eventList/events/taxi-events.ts";
import TaxiGetRouteInfoDto from "@/domains/dev/eventList/taxi-dto/taxi-get-route-info.dto.ts";
import TaxiRentDto from "@/domains/dev/eventList/taxi-dto/taxi-rent.dto.ts";
import TaxiStartDto from "@/domains/dev/eventList/taxi-dto/taxi-start.dto.ts";
import TaxiTakeOrderDto from "@/domains/dev/eventList/taxi-dto/taxi-take-order.dto.ts";

const eventList = {
  taxi: {
    getOrders: {
      name: TaxiEvents.GetOrders,
      dto: {},
    },
    getRouteInfo: {
      name: TaxiEvents.GetRouteInfo,
      dto: new TaxiGetRouteInfoDto(),
    },
    rent: {
      name: TaxiEvents.Rent,
      dto: new TaxiRentDto(),
    },
    start: {
      name: TaxiEvents.Start,
      dto: new TaxiStartDto(),
    },
    employment: {
      name: TaxiEvents.Employment,
      dto: {},
    },
    newOrder: {
      name: TaxiEvents.NewOrder,
      dto: {},
    },
    takeOrder: {
      name: TaxiEvents.TakeOrder,
      dto: new TaxiTakeOrderDto(),
    },
  },
  trade: {
    accept: {
      name: "TradeAccept",
      dto: new AcceptDto(),
    },
    create: {
      name: "TradeCreate",
      dto: new CreateDto(),
    },
    cancel: {
      name: "TradeCancel",
      dto: {},
    },
    update: {
      name: "TradeUpdate",
      dto: new UpdateDto(),
    },
  },
  bus: {
    getRoutes: {
      name: BusEvents.GetRoutes,
      dto: {},
    },
    getRentVehicles: {
      name: BusEvents.GetRentVehicles,
      dto: {},
    },
    selectRoute: {
      name: BusEvents.SelectRoute,
      dto: new SelectRouteDto(),
    },
    employment: {
      name: BusEvents.Employment,
      dto: {},
    },
    rent: {
      name: BusEvents.Rent,
      dto: new RentDto(),
    },
    startStop: {
      name: BusEvents.StartStop,
      dto: {},
    },
    process: {
      name: BusEvents.Process,
      dto: new ProcessDto(),
    },
  },
};

export default eventList;
